const validUuidV4Regex = new RegExp(
  "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}",
);
export const isUUID = idString => validUuidV4Regex.test(idString);
